package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class InvoiceRepository(private val httpClient: HttpClient) {
    suspend fun getInvoices(workplaceId: Long): Result<List<InvoiceDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/invoices").body()
    }
    suspend fun createInvoice(workplaceId: Long, req: CreateInvoiceRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/invoices") { setBody(req) }
    }
    suspend fun updateStatus(invoiceId: Long, req: UpdateInvoiceStatusRequest): Result<Unit> = runCatching {
        httpClient.put("invoices/$invoiceId/status") { setBody(req) }
    }
    suspend fun deleteInvoice(invoiceId: Long): Result<Unit> = runCatching {
        httpClient.delete("invoices/$invoiceId")
    }
}
